  (function () {
    var CUSTOM_PREFIX = 'vorelli:';
    var WHATSAPP_NUMBER = '447841530805';
    var WHATSAPP_URL = 'https://wa.me/' + WHATSAPP_NUMBER;
    var KLAVIYO_COMPANY_ID = 'XBbZLQ';
    var KLAVIYO_EMAIL_LIST_ID = 'TDNddM';
    var KLAVIYO_API_REVISION = '2026-04-15';
    var whatsappLinkObserver = null;
    var whatsappNormalizeFrame = null;
    var context = window.VorelliTrackingContext || {};
    var listItems = context.collection_items || [];
    var publishedListView = false;
    var publishedAuthorityView = false;
    var publishedAuthorityEngagement = false;
    var publishedCalculatorInteraction = false;
    var publishedPhoneNumberView = false;
    var publishedEngagedUser = false;
    var publishedHighIntentUser = false;
    var trackedTradeStarts = {};
    var trackedVideoThresholds = {};
    var recentActionEvents = {};
    var CONTACT_MARKET = "UK";
    var SAFE_ANALYTICS_PARAMS = {
      page_url: true,
      page_location: true,
      page_path: true,
      page_title: true,
      page_type: true,
      landing_page: true,
      landing_page_group: true,
      source_page: true,
      traffic_source: true,
      traffic_medium: true,
      campaign: true,
      campaign_id: true,
      ad_content: true,
      keyword: true,
      gclid: true,
      gbraid: true,
      wbraid: true,
      market: true,
      currency: true,
      value: true,
      transaction_id: true,
      tax: true,
      shipping: true,
      coupon: true,
      items: true,
      event_id: true,
      event_category: true,
      conversion_role: true,
      parent_event: true,
      lead_type: true,
      lead_tier: true,
      enquiry_type: true,
      client_role: true,
      customer_type: true,
      project_type: true,
      project_timeline: true,
      budget_range: true,
      room_or_area: true,
      quantity: true,
      specification_interest: true,
      preferred_contact_method: true,
      contact_method: true,
      contact_channel: true,
      contact_session_id: true,
      contact_attempt_id: true,
      crm_priority: true,
      email_marketing_consent: true,
      cta_location: true,
      cta_text: true,
      button_location: true,
      form_id: true,
      form_name: true,
      form_destination: true,
      product_id: true,
      product_sku: true,
      product_title: true,
      product_name: true,
      product_category: true,
      collection: true,
      collection_name: true,
      item_list_id: true,
      item_list_name: true,
      search_term: true,
      search_results_count: true,
      calculator_type: true,
      guide_name: true,
      engagement_trigger: true,
      high_intent_trigger: true,
      video_title: true,
      video_percent: true,
      download_name: true,
      download_type: true,
      tool_name: true
    };
    var SAFE_ITEM_PARAMS = {
      item_id: true,
      item_name: true,
      item_brand: true,
      item_category: true,
      item_collection: true,
      item_variant: true,
      price: true,
      quantity: true,
      currency: true,
      product_id: true,
      variant_id: true,
      product_url: true,
      item_price_band: true,
      google_business_vertical: true,
      index: true
    };
    var SAFE_IDENTIFIER_PARAMS = {
      transaction_id: true,
      event_id: true,
      contact_session_id: true,
      contact_attempt_id: true,
      campaign_id: true,
      gclid: true,
      gbraid: true,
      wbraid: true,
      product_id: true,
      product_sku: true,
      variant_id: true,
      item_id: true,
      item_list_id: true,
      form_id: true
    };
    var EMAIL_VALUE_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
    var PHONE_VALUE_PATTERN = /(?:\+?\d[\d\s().-]{7,}\d)/;

    var leadEvents = {
      contact_form_submit: true,
      quote_request_submit: true,
      trade_account_application: true,
      designer_enquiry: true,
      architect_enquiry: true,
      hospitality_enquiry: true,
      developer_enquiry: true,
      high_value_project_enquiry: true,
      project_enquiry: true,
      product_enquiry: true,
      sample_request: true,
      consultation_booking: true,
      request_callback: true,
      request_quote: true,
      request_sample: true,
      start_trade_application: true,
      submit_trade_application: true,
      luxury_project_lead: true
    };

    var eventAliases = {
      contact: 'contact_form_submit',
      quote_request: 'quote_request_submit',
      trade_application: 'trade_account_application',
      trade_enquiry: 'trade_account_application',
      product_enquiry_submit: 'product_enquiry'
    };

    function normalizeEventName(value) {
      var normalized = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9_]+/g, '_')
        .replace(/^_+|_+$/g, '');

      return eventAliases[normalized] || normalized;
    }

    var klaviyoLeadMetrics = {
      contact_form_submit: 'VORELLI Contact Form Submitted',
      quote_request_submit: 'VORELLI Quote Request Submitted',
      trade_account_application: 'VORELLI Trade Application Submitted',
      designer_enquiry: 'VORELLI Designer Enquiry Submitted',
      architect_enquiry: 'VORELLI Architect Enquiry Submitted',
      hospitality_enquiry: 'VORELLI Hospitality Enquiry Submitted',
      developer_enquiry: 'VORELLI Developer Enquiry Submitted',
      high_value_project_enquiry: 'VORELLI High Value Project Enquiry Submitted',
      project_enquiry: 'VORELLI Project Enquiry Submitted',
      product_enquiry: 'VORELLI Product Enquiry Submitted',
      sample_request: 'VORELLI Sample Request Submitted',
      consultation_booking: 'VORELLI Consultation Requested',
      request_callback: 'VORELLI Callback Requested'
    };

    function merge(target, source) {
      var output = target || {};
      var key;

      if (!source) {
        return output;
      }

      for (key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null && source[key] !== '') {
          output[key] = source[key];
        }
      }

      return output;
    }

    function pushKlaviyo(method, args) {
      try {
        if (window.klaviyo && typeof window.klaviyo[method] === 'function') {
          window.klaviyo[method].apply(window.klaviyo, args);
          return true;
        }

        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push([method].concat(args));
          return true;
        }
      } catch (error) {
        // Fall back to the legacy queue below.
      }

      try {
        window._learnq = window._learnq || [];
        window._learnq.push([method].concat(args));
        return true;
      } catch (error) {
        return false;
      }
    }

    function cleanUrl(url) {
      if (!url) {
        return '';
      }

      return String(url).split('#')[0];
    }

    function readQueryParam(params, name) {
      return params.get(name) || '';
    }

    function getAttribution() {
      var params = new URLSearchParams(window.location.search || '');
      var storageKey = 'vorelli_attribution';
      var stored = {};
      var current = {
        traffic_source: readQueryParam(params, 'utm_source'),
        traffic_medium: readQueryParam(params, 'utm_medium'),
        campaign: readQueryParam(params, 'utm_campaign'),
        campaign_id: readQueryParam(params, 'utm_id'),
        ad_content: readQueryParam(params, 'utm_content'),
        keyword: readQueryParam(params, 'utm_term'),
        gclid: readQueryParam(params, 'gclid'),
        gbraid: readQueryParam(params, 'gbraid'),
        wbraid: readQueryParam(params, 'wbraid'),
        landing_page: cleanUrl(window.location.href)
      };
      var hasCurrentAttribution = current.traffic_source || current.campaign || current.keyword || current.gclid || current.gbraid || current.wbraid;

      try {
        stored = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}') || {};
      } catch (error) {
        stored = {};
      }

      if (hasCurrentAttribution) {
        stored = merge(stored, current);

        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(stored));
        } catch (error) {
          return stored;
        }
      }

      if (!stored.landing_page) {
        stored.landing_page = cleanUrl(window.location.href);
      }

      return stored;
    }

    function pagePayload() {
      var product = context.product || {};
      var collection = context.collection || {};
      var landingPageGroup = classifyLandingPage(window.location.pathname);

      return merge({
        page_url: cleanUrl(window.location.href),
        page_path: window.location.pathname,
        page_title: document.title,
        page_type: context.page && context.page.type,
        landing_page_group: landingPageGroup,
        source_page: classifySourcePage(landingPageGroup),
        product_title: product.item_name,
        product_sku: product.item_id,
        collection: collection.title || product.item_collection
      }, getAttribution());
    }

    function safeAnalyticsUrl(value) {
      var url;

      if (!value) {
        return '';
      }

      try {
        url = new URL(String(value), window.location.origin);
      } catch (error) {
        return '';
      }

      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return '';
      }

      return url.origin + url.pathname;
    }

    function safeAnalyticsValue(value, key) {
      var normalized;

      if (typeof value === 'number' || typeof value === 'boolean') {
        return value;
      }

      if (typeof value !== 'string') {
        return undefined;
      }

      normalized = value.replace(/\s+/g, ' ').trim();

      if (!normalized || normalized.length > 180 || (!SAFE_IDENTIFIER_PARAMS[key] && (EMAIL_VALUE_PATTERN.test(normalized) || PHONE_VALUE_PATTERN.test(normalized)))) {
        return undefined;
      }

      return normalized;
    }

    function safeAnalyticsItems(items) {
      if (!Array.isArray(items)) {
        return undefined;
      }

      return items.slice(0, 200).map(function (item) {
        var output = {};
        var key;
        var value;

        if (!item || typeof item !== 'object') {
          return output;
        }

        for (key in item) {
          if (!Object.prototype.hasOwnProperty.call(item, key) || !SAFE_ITEM_PARAMS[key]) {
            continue;
          }

          value = item[key];

          if (key === 'product_url') {
            value = safeAnalyticsUrl(value);
          } else {
            value = safeAnalyticsValue(value, key);
          }

          if (value !== undefined && value !== '') {
            output[key] = value;
          }
        }

        return output;
      });
    }

    function safeAnalyticsPayload(input) {
      var output = {};
      var key;
      var value;

      input = input || {};

      for (key in input) {
        if (!Object.prototype.hasOwnProperty.call(input, key) || !SAFE_ANALYTICS_PARAMS[key]) {
          continue;
        }

        value = input[key];

        if (key === 'items') {
          value = safeAnalyticsItems(value);
        } else if (key === 'page_url' || key === 'page_location' || key === 'landing_page' || key === 'form_destination') {
          value = safeAnalyticsUrl(value);
        } else {
          value = safeAnalyticsValue(value, key);
        }

        if (value !== undefined && value !== '') {
          output[key] = value;
        }
      }

      output.market = 'UK';
      output.pii_stripped = true;
      output.event_source = 'shopify_theme';

      return output;
    }

    function publish(eventName, payload) {
      var eventPayload = safeAnalyticsPayload(merge(pagePayload(), payload || {}));
      eventPayload.event_id = [
        'theme',
        eventName,
        Date.now(),
        Math.random().toString(36).slice(2, 9)
      ].join('_');

      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(CUSTOM_PREFIX + eventName, eventPayload);
        return;
      }

      window.dataLayer = window.dataLayer || [];

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventPayload);
      } else {
        window.dataLayer.push(merge({ event: eventName }, eventPayload));
      }
    }

    function publishOncePerSession(storageKey, eventName, payload) {
      try {
        if (window.sessionStorage.getItem(storageKey)) {
          return;
        }

        window.sessionStorage.setItem(storageKey, '1');
      } catch (error) {
        if (recentActionEvents[storageKey]) {
          return;
        }

        recentActionEvents[storageKey] = Date.now();
      }

      publish(eventName, payload);
    }

    function publishEngagedUser(trigger) {
      if (publishedEngagedUser) {
        return;
      }

      publishedEngagedUser = true;
      publishOncePerSession('vorelli_engaged_user', 'engaged_user', {
        event_category: 'journey',
        engagement_trigger: trigger,
        conversion_role: 'diagnostic'
      });
    }

    function publishHighIntentUser(trigger, payload) {
      if (publishedHighIntentUser) {
        return;
      }

      publishedHighIntentUser = true;
      publishOncePerSession('vorelli_high_intent_user', 'high_intent_user', merge({
        event_category: 'journey',
        high_intent_trigger: trigger,
        conversion_role: 'diagnostic'
      }, payload || {}));
    }

    function normalizePath(url) {
      var anchor = document.createElement('a');
      anchor.href = url;
      return anchor.pathname.replace(/\/$/, '');
    }

    function findListItemFromLink(link) {
      var linkPath;
      var i;
      var itemPath;

      if (!link || !listItems.length) {
        return null;
      }

      linkPath = normalizePath(link.href);

      for (i = 0; i < listItems.length; i += 1) {
        itemPath = normalizePath(listItems[i].product_url);

        if (linkPath === itemPath || linkPath.indexOf(itemPath) > -1 || itemPath.indexOf(linkPath) > -1) {
          return listItems[i];
        }
      }

      return null;
    }

    function getButtonLocation(element) {
      var explicit = element.getAttribute('data-ga4-location') || element.getAttribute('data-button-location');
      var label = element.getAttribute('aria-label') || element.getAttribute('title') || '';
      var className = element.className ? String(element.className) : '';

      if (explicit) {
        return explicit;
      }

      if (element.closest('header, .header, .site-header')) {
        return 'header';
      }

      if (element.closest('footer, .footer, .site-footer')) {
        return 'footer';
      }

      if (element.closest('.product, [data-product], .product-form, main')) {
        if (context.product && context.product.item_name) {
          return 'product_page';
        }
      }

      if (/floating|sticky|fixed/i.test(className + ' ' + label)) {
        return 'floating';
      }

      if (/contact/i.test(window.location.pathname)) {
        return 'contact_page';
      }

      return label || 'body';
    }

    function classifySourcePage(landingPageGroup) {
      var path = String(window.location.pathname || '').toLowerCase();

      if (landingPageGroup && landingPageGroup.indexOf('authority_guide_') === 0) {
        if (landingPageGroup === 'authority_guide_staircase_chandelier_size') {
          return 'staircase_calculator_page';
        }

        return 'authority_guide_page';
      }

      if (context.product && context.product.item_name) {
        return 'product_page';
      }

      if (context.collection && context.collection.title) {
        return 'collection_page';
      }

      if (/contact/.test(path)) {
        return 'contact_page';
      }

      return 'standard_page';
    }

    function classifyLandingPage(pathname) {
      var path = String(pathname || '').toLowerCase();

      if (/staircase-chandelier-size-(guide|calculator)/.test(path)) {
        return 'authority_guide_staircase_chandelier_size';
      }

      if (/long-drop-chandelier-guide/.test(path)) {
        return 'authority_guide_long_drop_chandelier';
      }

      if (/double-height-chandelier-guide/.test(path)) {
        return 'authority_guide_double_height_chandelier';
      }

      if (/entrance-hall-chandelier-guide/.test(path)) {
        return 'authority_guide_entrance_hall_chandelier';
      }

      if (/dining-room-chandelier-size-guide/.test(path)) {
        return 'authority_guide_dining_room_chandelier';
      }

      if (/luxury-wall-lights-guide/.test(path)) {
        return 'authority_guide_luxury_wall_lights';
      }

      if (/staircase/.test(path) && /chandelier/.test(path)) {
        return 'staircase_chandelier';
      }

      if (/long-drop|long_drop/.test(path) && /chandelier/.test(path)) {
        return 'long_drop_chandelier';
      }

      if (/double-height|double_height/.test(path) && /chandelier/.test(path)) {
        return 'double_height_chandelier';
      }

      if (/dining/.test(path) && /chandelier/.test(path)) {
        return 'dining_room_chandelier';
      }

      if (/kitchen-island|kitchen_island/.test(path) && /chandelier|lighting|light/.test(path)) {
        return 'kitchen_island_chandelier';
      }

      if (/wall-light|wall_light|wall-lights|wall_lights/.test(path)) {
        return 'wall_light';
      }

      if (/pendant-light|pendant_light|pendant-lights|pendant_lights/.test(path)) {
        return 'pendant_light';
      }

      if (/table-lamp|table_lamp|table-lamps|table_lamps/.test(path)) {
        return 'table_lamp';
      }

      if (/floor-lamp|floor_lamp|floor-lamps|floor_lamps/.test(path)) {
        return 'floor_lamp';
      }

      if (/furniture/.test(path)) {
        return 'furniture';
      }

      if (/mirror|mirrors/.test(path)) {
        return 'luxury_mirror';
      }

      if (/accessor|accessories/.test(path)) {
        return 'luxury_accessory';
      }

      if (/luxury/.test(path) && /chandelier/.test(path)) {
        return 'luxury_chandelier';
      }

      return '';
    }

    function classifyForm(form) {
      var declared = form.getAttribute('data-ga4-event');
      var metadataText = [
        form.id,
        form.getAttribute('name'),
        form.getAttribute('action'),
        form.className,
        form.getAttribute('data-form-type'),
        document.title,
        window.location.pathname
      ].join(' ').toLowerCase();
      var formText = [
        metadataText
      ].join(' ');
      var elements = form.elements ? Array.prototype.slice.call(form.elements) : [];

      elements.forEach(function (element) {
        formText += ' ' + [
          element.id,
          element.name,
          element.type,
          element.className,
          element.getAttribute && element.getAttribute('placeholder'),
          element.getAttribute && element.getAttribute('aria-label'),
          element.getAttribute && element.getAttribute('title')
        ].join(' ').toLowerCase();

        if (element.type === 'hidden' && element.value) {
          formText += ' ' + String(element.value).toLowerCase();
        }
      });

      if (declared && eventAliases[declared]) {
        return eventAliases[declared];
      }

      if (declared && leadEvents[declared]) {
        return declared;
      }

      if (/newsletter|search|login|register|password|cart|localization/.test(formText)) {
        return '';
      }

      if (/trade[_ -]?account|trade[_ -]?application|account[_ -]?application/.test(formText)) {
        return 'trade_account_application';
      }

      if (/callback|call back|call-back|request a call|request call/.test(formText)) {
        return 'request_callback';
      }

      if (/consultation|booking|appointment|calendly/.test(formText)) {
        return 'consultation_booking';
      }

      if (/sample|swatch|finish/.test(formText) && /request|order|send|kit/.test(formText)) {
        return 'sample_request';
      }

      if (/quote|quotation|rfq/.test(formText)) {
        return 'quote_request_submit';
      }

      if (/project|project[_ -]?type|estimated[_ -]?budget|budget|ceiling|staircase|designer[_ -]?architect|bespoke|custom|large scale|installation|calculator|plans|renders/.test(formText)) {
        return 'project_enquiry';
      }

      if (context.product && /product|enquiry|inquiry|question|ask|contact/.test(formText)) {
        return 'product_enquiry';
      }

      if (/contact|enquiry|inquiry/.test(formText)) {
        return 'contact_form_submit';
      }

      return '';
    }

    function collectFormValues(form) {
      var values = [];
      var fields = form.elements ? Array.prototype.slice.call(form.elements) : [];

      fields.forEach(function (field) {
        var value;

        if (!field || field.disabled || !field.name) {
          return;
        }

        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
          return;
        }

        value = field.value;

        if (value) {
          values.push(String(field.name) + ' ' + String(value));
        }
      });

      return values.join(' ').toLowerCase();
    }

    function formSuggestsLuxuryProject(formValues) {
      return /50,000|50000|15,000|15000|palace|estate|mansion|hospitality|hotel|developer|large[- ]?scale|double height|staircase|penthouse|villa/.test(formValues);
    }

    function extraSubmitEvents(eventName, formValues) {
      var events = [];

      if (eventName === 'quote_request_submit') {
        events.push('request_quote');
      }

      if (eventName === 'trade_account_application') {
        events.push('submit_trade_application');
      }

      if (eventName === 'sample_request') {
        events.push('request_sample');
      }

      if (/hospitality|hotel|restaurant|resort|lobby/.test(formValues)) {
        events.push('hospitality_enquiry');
      }

      if (/developer|development|property developer|multi[- ]?unit/.test(formValues)) {
        events.push('developer_enquiry');
      }

      if (/architect|architectural|specifier/.test(formValues)) {
        events.push('architect_enquiry');
      }

      if (/designer|interior designer|trade or interior/.test(formValues)) {
        events.push('designer_enquiry');
      }

      if (formSuggestsLuxuryProject(formValues)) {
        events.push('high_value_project_enquiry');
        events.push('luxury_project_lead');
      }

      return events;
    }

    function extractUserData(form) {
      var emailInput = form.querySelector('input[type="email"], input[name*="email" i]');
      var phoneInput = form.querySelector('input[type="tel"], input[name*="phone" i], input[name*="mobile" i]');
      var firstNameInput = form.querySelector('input[name*="first" i]');
      var lastNameInput = form.querySelector('input[name*="last" i]');
      var userData = {};

      if (emailInput && emailInput.value) {
        userData.email = emailInput.value.trim().toLowerCase();
      }

      if (phoneInput && phoneInput.value) {
        userData.phone_number = phoneInput.value.trim();
      }

      if (firstNameInput && firstNameInput.value) {
        userData.first_name = firstNameInput.value.trim();
      }

      if (lastNameInput && lastNameInput.value) {
        userData.last_name = lastNameInput.value.trim();
      }

      return userData;
    }

    function leadPropertyKey(field) {
      var source = [
        field.name,
        field.id,
        field.getAttribute && field.getAttribute('placeholder'),
        field.getAttribute && field.getAttribute('aria-label'),
        field.getAttribute && field.getAttribute('title')
      ].join(' ').toLowerCase().replace(/contact|\[|\]|_/g, ' ');

      if (field.hasAttribute && field.hasAttribute('data-vorelli-email-marketing-consent')) {
        return 'email_marketing_consent';
      }

      if (field.type === 'email' || field.type === 'tel' || /email address|phone|mobile|first name|last name|full name|your name/.test(source)) {
        return '';
      }

      if (/body|message|comment|note|details|description/.test(source)) {
        return '';
      }

      if (/email marketing|marketing consent|project updates|private project updates|updates/.test(source)) {
        return 'email_marketing_consent';
      }

      if (/tracking/.test(source)) {
        return 'tracking_event';
      }

      if (/source/.test(source)) {
        return 'lead_source';
      }

      if (/company|business|studio|practice|organisation|organization/.test(source)) {
        return 'organization';
      }

      if (/role|profession|trade/.test(source)) {
        return 'client_role';
      }

      if (/location|site|city|country|address/.test(source)) {
        return 'project_location';
      }

      if (/timeline|deadline|timeframe|required|installation date/.test(source)) {
        return 'project_timeline';
      }

      if (/budget|spend|value/.test(source)) {
        return 'budget_range';
      }

      if (/project type|type of project|property type|property/.test(source)) {
        return 'project_type';
      }

      if (/room|area|space/.test(source)) {
        return 'room_or_area';
      }

      if (/quantity|number of|pieces|units/.test(source)) {
        return 'quantity';
      }

      if (/finish|material|colour|color|size|drop|diameter|height|width/.test(source)) {
        return 'specification_interest';
      }

      if (/contact method|preferred contact|whatsapp/.test(source)) {
        return 'preferred_contact_method';
      }

      return '';
    }

    function cleanLeadPropertyValue(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 180);
    }

    function injectEmailMarketingConsentStyles() {
      var style;

      if (document.getElementById('vorelli-email-marketing-consent-styles')) {
        return;
      }

      style = document.createElement('style');
      style.id = 'vorelli-email-marketing-consent-styles';
      style.textContent = [
        '[data-vorelli-email-marketing-consent-wrap] { grid-column: 1 / -1; margin-top: -2px; }',
        '[data-vorelli-email-marketing-consent-wrap] .vorelli-email-marketing-consent { display: flex; align-items: flex-start; gap: 10px; margin: 0; color: inherit; font-size: 0.86rem; font-weight: 400; line-height: 1.45; text-transform: none; letter-spacing: 0; }',
        '[data-vorelli-email-marketing-consent-wrap] [data-vorelli-email-marketing-consent] { width: auto !important; min-width: 16px; min-height: 16px; margin: 3px 0 0; padding: 0; flex: 0 0 auto; }',
        '.vsl-lead-form [data-vorelli-email-marketing-consent-wrap] { margin-top: 0; }'
      ].join('\n');
      document.head.appendChild(style);
    }

    function isEmailMarketingConsentCandidate(form) {
      var eventName;
      var formText;

      if (!form || form.querySelector('[data-vorelli-email-marketing-consent]')) {
        return false;
      }

      if (!form.querySelector('input[type="email"], input[name*="email" i]')) {
        return false;
      }

      formText = [
        form.id,
        form.getAttribute('name'),
        form.getAttribute('action'),
        form.className,
        form.textContent
      ].join(' ').toLowerCase();

      if (/newsletter|search|login|register|password|cart|localization/.test(formText)) {
        return false;
      }

      eventName = classifyForm(form);

      return Boolean(eventName && leadEvents[eventName]);
    }

    function addEmailMarketingConsentField(form) {
      var wrapper;
      var label;
      var input;
      var copy;
      var submit;
      var insertionTarget;
      var checkboxId;

      if (!isEmailMarketingConsentCandidate(form)) {
        return;
      }

      injectEmailMarketingConsentStyles();

      checkboxId = (form.id || 'vorelli-lead-form').replace(/[^a-zA-Z0-9_-]/g, '') + '-email-marketing-consent';
      wrapper = document.createElement('div');
      wrapper.className = /vsl-lead-form/.test(String(form.className || '')) ? 'vsl-field vsl-field-wide vsl-consent' : 'vorelli-email-marketing-consent-field';
      wrapper.setAttribute('data-vorelli-email-marketing-consent-wrap', '');

      label = document.createElement('label');
      label.className = 'vorelli-email-marketing-consent';
      label.setAttribute('for', checkboxId);

      input = document.createElement('input');
      input.id = checkboxId;
      input.name = 'contact[Email marketing consent]';
      input.type = 'checkbox';
      input.value = 'yes';
      input.setAttribute('data-vorelli-email-marketing-consent', '');

      copy = document.createElement('span');
      copy.textContent = 'Email me private project updates, specification guidance and relevant VORELLI availability.';

      label.appendChild(input);
      label.appendChild(copy);
      wrapper.appendChild(label);

      submit = form.querySelector('button[type="submit"], input[type="submit"]');
      insertionTarget = form.querySelector('.vsl-submit-row') || form.querySelector('.vcc-form-grid + button') || submit;

      if (insertionTarget && insertionTarget.parentNode) {
        insertionTarget.parentNode.insertBefore(wrapper, insertionTarget);
      } else {
        form.appendChild(wrapper);
      }
    }

    function hydrateEmailMarketingConsentFields() {
      var forms = document.querySelectorAll('form');
      var i;

      for (i = 0; i < forms.length; i += 1) {
        addEmailMarketingConsentField(forms[i]);
      }
    }

    function collectStructuredLeadProperties(form) {
      var properties = {};
      var fields = form.elements ? Array.prototype.slice.call(form.elements) : [];

      fields.forEach(function (field) {
        var key;
        var value;

        if (!field || field.disabled || !field.name) {
          return;
        }

        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
          return;
        }

        key = leadPropertyKey(field);
        value = cleanLeadPropertyValue(field.value);

        if (!key || !value) {
          return;
        }

        properties[key] = properties[key] ? properties[key] + ', ' + value : value;
      });

      return properties;
    }

    function isHighValueLead(eventName, formValues) {
      return eventName === 'high_value_project_enquiry' ||
        eventName === 'hospitality_enquiry' ||
        eventName === 'developer_enquiry' ||
        eventName === 'architect_enquiry' ||
        formSuggestsLuxuryProject(formValues || '');
    }

    function trackKlaviyoLeadEvent(eventName, payload) {
      var metricName = klaviyoLeadMetrics[eventName];
      var userData;
      var identifyProperties = {};
      var eventProperties;

      if (!metricName || !payload) {
        return;
      }

      userData = payload.user_data || {};

      if (userData.email) {
        identifyProperties.email = userData.email;
      }

      if (userData.phone_number) {
        identifyProperties.phone_number = userData.phone_number;
      }

      if (userData.first_name) {
        identifyProperties.first_name = userData.first_name;
      }

      if (userData.last_name) {
        identifyProperties.last_name = userData.last_name;
      }

      if (payload.email_marketing_consent === 'yes') {
        identifyProperties.email_marketing_consent = 'yes';
        identifyProperties.email_marketing_consent_source = payload.lead_source || payload.form_destination || eventName;
        identifyProperties.email_marketing_consent_event = eventName;
      }

      if (identifyProperties.email || identifyProperties.phone_number) {
        pushKlaviyo('identify', [identifyProperties]);
      }

      eventProperties = merge(pagePayload(), payload);
      delete eventProperties.user_data;
      eventProperties.klaviyo_metric = metricName;
      eventProperties.klaviyo_source = 'shopify_theme_enquiry_tracking';

      pushKlaviyo('track', [metricName, eventProperties]);
    }

    function subscribeKlaviyoEmailMarketing(eventName, payload) {
      var userData;
      var profileAttributes;
      var subscriptionPayload;

      if (!payload || payload.email_marketing_consent !== 'yes' || !window.fetch) {
        return;
      }

      userData = payload.user_data || {};

      if (!userData.email) {
        return;
      }

      profileAttributes = {
        email: userData.email,
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED'
            }
          }
        },
        properties: {
          email_marketing_consent_source: payload.lead_source || payload.form_destination || 'VORELLI Shopify lead form',
          email_marketing_consent_event: eventName,
          email_marketing_consent_page: window.location.href,
          lead_type: payload.lead_type,
          lead_tier: payload.lead_tier,
          crm_priority: payload.crm_priority
        }
      };

      if (userData.first_name) {
        profileAttributes.first_name = userData.first_name;
      }

      if (userData.last_name) {
        profileAttributes.last_name = userData.last_name;
      }

      if (payload.organization) {
        profileAttributes.organization = payload.organization;
      }

      subscriptionPayload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'VORELLI Shopify lead form - ' + eventName,
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_EMAIL_LIST_ID
              }
            }
          }
        }
      };

      window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
        method: 'POST',
        keepalive: true,
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: KLAVIYO_API_REVISION
        },
        body: JSON.stringify(subscriptionPayload)
      }).catch(function () {});
    }

    function isSpecSheetDownload(link) {
      var href = String(link.getAttribute('href') || '').toLowerCase();
      var text = String(link.textContent || link.getAttribute('aria-label') || '').toLowerCase();

      return /\.(pdf|doc|docx)(\?|$)/.test(href) && /spec|specification|technical|tear sheet|datasheet|data sheet/.test(href + ' ' + text);
    }

    function isBrochureDownload(link) {
      var href = String(link.getAttribute('href') || '').toLowerCase();
      var text = String(link.textContent || link.getAttribute('aria-label') || '').toLowerCase();

      return /\.(pdf|doc|docx)(\?|$)/.test(href) && /brochure|catalogue|catalog|lookbook|download/.test(href + ' ' + text);
    }

    function isWhatsAppLink(link) {
      var href = String(link.getAttribute('href') || '');
      var label = String(link.textContent || link.getAttribute('aria-label') || link.getAttribute('title') || '').toLowerCase();

      if (/^tel:/i.test(href) || /^mailto:/i.test(href)) {
        return false;
      }

      return /^https?:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href) || (/whatsapp/.test(label) && href.indexOf(WHATSAPP_NUMBER) > -1);
    }

    function normalizeWhatsAppLink(link) {
      var href = String(link.getAttribute('href') || '');
      var query = '';

      if (!isWhatsAppLink(link)) {
        return;
      }

      try {
        var url = new URL(href, window.location.origin);
        var existingText = url.searchParams.get('text');

        if (existingText !== null) {
          var cleanText = existingText.replace(/(?:\r?\n)*[ \t]*VORELLI enquiry reference:[ \t]*vca_[a-z0-9_]+[ \t]*(?=\r?\n|$)/gi, '');
          if (cleanText !== existingText) {
            if (cleanText) {
              url.searchParams.set('text', cleanText);
            } else {
              url.searchParams.delete('text');
            }
          }
        }
        query = url.search;
      } catch (error) {
        query = '';
      }

      var normalizedHref = WHATSAPP_URL + query;
      if (href !== normalizedHref) {
        link.setAttribute('href', normalizedHref);
      }
    }

    function normalizeWhatsAppLinks() {
      var links = document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="447841530805"]');
      var i;

      for (i = 0; i < links.length; i += 1) {
        normalizeWhatsAppLink(links[i]);
      }
    }

    function queueWhatsAppLinkNormalization() {
      if (whatsappNormalizeFrame !== null) {
        return;
      }

      whatsappNormalizeFrame = window.requestAnimationFrame(function () {
        whatsappNormalizeFrame = null;
        normalizeWhatsAppLinks();
      });
    }

    function watchWhatsAppLinks() {
      normalizeWhatsAppLinks();
      window.setTimeout(normalizeWhatsAppLinks, 250);
      window.setTimeout(normalizeWhatsAppLinks, 1000);
      window.setTimeout(normalizeWhatsAppLinks, 2500);
      window.setTimeout(normalizeWhatsAppLinks, 5000);

      if (!window.MutationObserver || whatsappLinkObserver || !document.documentElement) {
        return;
      }

      whatsappLinkObserver = new MutationObserver(queueWhatsAppLinkNormalization);
      whatsappLinkObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['href'],
        childList: true,
        subtree: true
      });
    }

    function closestLink(target) {
      if (!target) {
        return null;
      }

      if (target.closest) {
        return target.closest('a[href]');
      }

      if (target.parentElement && target.parentElement.closest) {
        return target.parentElement.closest('a[href]');
      }

      return null;
    }

    function randomReference(prefix) {
      var randomPart = '';

      try {
        if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
          var bytes = new Uint8Array(6);
          window.crypto.getRandomValues(bytes);
          randomPart = Array.prototype.map.call(bytes, function (byte) {
            return byte.toString(36);
          }).join('').slice(0, 10);
        }
      } catch (error) {
        randomPart = '';
      }

      if (!randomPart) {
        randomPart = Math.random().toString(36).slice(2, 12);
      }

      return [prefix, CONTACT_MARKET.toLowerCase(), Date.now().toString(36), randomPart].join('_');
    }

    function contactSessionId() {
      var key = 'vorelli_contact_session_id';
      var value = '';

      try {
        value = window.sessionStorage.getItem(key) || '';
        if (!value) {
          value = randomReference('vcs');
          window.sessionStorage.setItem(key, value);
        }
      } catch (error) {
        value = randomReference('vcs');
      }

      return value;
    }

    function appendEmailReference(link, reference) {
      var href = String(link.getAttribute('href') || '');

      try {
        var url = new URL(href);
        var subject = url.searchParams.get('subject') || 'VORELLI private enquiry';

        if (subject.indexOf(reference) === -1) {
          url.searchParams.set('subject', subject + ' [' + reference + ']');
          link.setAttribute('href', url.toString());
        }
      } catch (error) {
        // Keep the original mail destination when URL parsing is unavailable.
      }
    }

    function publishActionLink(link) {
      var href = link.getAttribute('href') || '';
      var buttonLocation = getButtonLocation(link);
      var declaredEventName = normalizeEventName(link.getAttribute('data-ga4-event') || '');
      var actionEventName = '';
      var actionPayload = {};
      var contactAttemptId = randomReference('vca');
      var sessionId = contactSessionId();
      var dedupeKey;
      var now;

      if (declaredEventName && leadEvents[declaredEventName]) {
        actionEventName = declaredEventName;
        actionPayload = {
          button_location: buttonLocation,
          link_url: cleanUrl(link.href),
          lead_context: link.getAttribute('data-vorelli-lead-context') || ''
        };
      } else if (isWhatsAppLink(link)) {
        normalizeWhatsAppLink(link);
        actionEventName = 'whatsapp_click';
        actionPayload = {
          button_location: buttonLocation,
          link_url: cleanUrl(link.href),
          market: CONTACT_MARKET,
          contact_channel: 'whatsapp',
          contact_session_id: sessionId,
          contact_attempt_id: contactAttemptId,
          conversion_role: 'secondary'
        };
      } else if (/^tel:/i.test(href)) {
        actionEventName = 'phone_click';
        actionPayload = {
          button_location: buttonLocation,
          link_url: href,
          market: CONTACT_MARKET,
          contact_channel: 'phone',
          contact_session_id: sessionId,
          contact_attempt_id: contactAttemptId,
          conversion_role: 'secondary'
        };
      } else if (/^mailto:/i.test(href)) {
        actionEventName = 'email_click';
        appendEmailReference(link, contactAttemptId);
        actionPayload = {
          button_location: buttonLocation,
          link_url: href.split('?')[0],
          market: CONTACT_MARKET,
          contact_channel: 'email',
          contact_session_id: sessionId,
          contact_attempt_id: contactAttemptId,
          conversion_role: 'secondary'
        };
      } else if (isSpecSheetDownload(link)) {
        actionEventName = 'download_spec_sheet';
        actionPayload = {
          button_location: buttonLocation,
          link_url: cleanUrl(link.href)
        };
      } else if (isBrochureDownload(link)) {
        actionEventName = 'brochure_download';
        actionPayload = {
          button_location: buttonLocation,
          link_url: cleanUrl(link.href)
        };
      } else if (/sample|swatch|finish/i.test(href + ' ' + link.textContent) && /request|order|kit|sample/i.test(href + ' ' + link.textContent)) {
        actionEventName = 'sample_request';
        actionPayload = {
          button_location: buttonLocation,
          link_url: cleanUrl(link.href)
        };
      }

      if (!actionEventName) {
        return;
      }

      now = Date.now();
      dedupeKey = actionEventName + ':' + actionPayload.link_url;

      if (recentActionEvents[dedupeKey] && now - recentActionEvents[dedupeKey] < 1000) {
        return;
      }

      recentActionEvents[dedupeKey] = now;
      publish(actionEventName, actionPayload);

      if (actionEventName === 'whatsapp_click') {
        publish('click_whatsapp', merge({
          event_category: 'contact_click',
          conversion_role: 'diagnostic'
        }, actionPayload));
        publishHighIntentUser('whatsapp_click', actionPayload);
      } else if (leadEvents[actionEventName]) {
        publishHighIntentUser(actionEventName, actionPayload);
      } else if (actionEventName === 'phone_click') {
        publish('click_phone_number', merge({
          event_category: 'contact_click',
          conversion_role: 'diagnostic'
        }, actionPayload));
        publishHighIntentUser('phone_click', actionPayload);
      } else if (actionEventName === 'brochure_download') {
        publish('download_brochure', merge({
          event_category: 'content_download',
          conversion_role: 'diagnostic'
        }, actionPayload));
        publishHighIntentUser('brochure_download', actionPayload);
      } else if (actionEventName === 'download_spec_sheet') {
        publishHighIntentUser('download_spec_sheet', actionPayload);
      } else if (actionEventName === 'sample_request') {
        publish('request_sample', merge({
          event_category: 'lead',
          conversion_role: 'diagnostic'
        }, actionPayload));
        publishHighIntentUser('sample_request', actionPayload);
      }
    }

    function onActionIntent(event) {
      var link = closestLink(event.target);

      if (!link) {
        return;
      }

      publishActionLink(link);
    }

    function onClick(event) {
      var link = closestLink(event.target);
      var item;

      if (!link) {
        return;
      }

      publishActionLink(link);

      item = findListItemFromLink(link);

      if (item) {
        publish('select_item', {
          item_list_id: context.collection && context.collection.handle,
          item_list_name: context.collection && context.collection.title,
          items: [item]
        });
      }
    }

    function onSubmit(event) {
      var form = event.target;
      var eventName;
      var userData;
      var payload;
      var formValues;
      var relatedEvents;
      var relatedPayload;

      if (!form || String(form.nodeName).toLowerCase() !== 'form') {
        return;
      }

      eventName = classifyForm(form);
      formValues = collectFormValues(form);

      if (!eventName) {
        return;
      }

      userData = extractUserData(form);
      payload = {
        form_id: form.id,
        form_name: form.getAttribute('name'),
        form_destination: form.getAttribute('action') || window.location.href,
        lead_type: eventName,
        lead_tier: isHighValueLead(eventName, formValues) ? 'high_value_project' : 'standard_enquiry',
        crm_priority: isHighValueLead(eventName, formValues) ? 'urgent_sales_review' : 'standard_sales_review'
      };
      merge(payload, collectStructuredLeadProperties(form));

      if (userData.email || userData.phone_number || userData.first_name || userData.last_name) {
        payload.user_data = userData;
      }

      publish(eventName, payload);
      trackKlaviyoLeadEvent(eventName, payload);
      subscribeKlaviyoEmailMarketing(eventName, payload);

      if (eventName === 'quote_request_submit' || eventName === 'consultation_booking' || eventName === 'project_enquiry' || eventName === 'product_enquiry' || eventName === 'trade_account_application' || eventName === 'designer_enquiry' || eventName === 'architect_enquiry' || eventName === 'hospitality_enquiry' || eventName === 'developer_enquiry' || eventName === 'high_value_project_enquiry' || eventName === 'request_callback') {
        publishHighIntentUser(eventName, payload);
      }

      relatedEvents = extraSubmitEvents(eventName, formValues);

      relatedEvents.forEach(function (relatedEventName) {
        if (relatedEventName !== eventName) {
          relatedPayload = merge({
            parent_event: eventName,
            conversion_role: 'diagnostic'
          }, payload);
          publish(relatedEventName, relatedPayload);
          trackKlaviyoLeadEvent(relatedEventName, relatedPayload);
        }
      });
    }

    function onFormStart(event) {
      var form = event.target && event.target.closest ? event.target.closest('form') : null;
      var eventName;
      var formKey;

      if (!form) {
        return;
      }

      eventName = classifyForm(form);

      if (eventName !== 'trade_account_application') {
        return;
      }

      formKey = form.id || form.getAttribute('name') || form.getAttribute('action') || 'trade_form';

      if (trackedTradeStarts[formKey]) {
        return;
      }

      trackedTradeStarts[formKey] = true;
      publish('start_trade_application', {
        form_id: form.id,
        form_name: form.getAttribute('name'),
        form_destination: form.getAttribute('action') || window.location.href,
        lead_type: 'trade_account_application',
        conversion_role: 'diagnostic'
      });
      publishHighIntentUser('start_trade_application');
    }

    function publishListView() {
      if (publishedListView || !listItems.length || !context.collection) {
        return;
      }

      publishedListView = true;

      publish('view_item_list', {
        item_list_id: context.collection.handle,
        item_list_name: context.collection.title,
        items: listItems
      });
    }

    function publishAuthorityView() {
      var payload = pagePayload();

      if (publishedAuthorityView || !payload.landing_page_group || payload.landing_page_group.indexOf('authority_guide_') !== 0) {
        return;
      }

      publishedAuthorityView = true;
      publish('authority_guide_view', {
        guide_name: payload.landing_page_group,
        content_group: 'authority_guides'
      });
    }

    function publishAuthorityEngagement(trigger) {
      var payload = pagePayload();

      if (publishedAuthorityEngagement || !payload.landing_page_group || payload.landing_page_group.indexOf('authority_guide_') !== 0) {
        return;
      }

      publishedAuthorityEngagement = true;
      publish('authority_guide_engagement', {
        guide_name: payload.landing_page_group,
        engagement_trigger: trigger,
        content_group: 'authority_guides'
      });
    }

    function publishCalculatorInteraction(trigger) {
      var payload = pagePayload();

      if (publishedCalculatorInteraction || payload.landing_page_group !== 'authority_guide_staircase_chandelier_size') {
        return;
      }

      publishedCalculatorInteraction = true;
      publish('staircase_calculator_interaction', {
        guide_name: payload.landing_page_group,
        calculator_trigger: trigger,
        content_group: 'authority_guides'
      });
    }

    function publishPhoneNumberView() {
      var links = document.querySelectorAll('a[href^="tel:"]');

      if (publishedPhoneNumberView || !links.length) {
        return;
      }

      publishedPhoneNumberView = true;
      publishOncePerSession('vorelli_view_phone_number', 'view_phone_number', {
        event_category: 'contact_visibility',
        visible_phone_count: links.length,
        conversion_role: 'diagnostic'
      });
    }

    function publishReturningVisitorState() {
      var visitCount = 1;

      try {
        visitCount = Number(window.localStorage.getItem('vorelli_visit_count') || '0') + 1;
        window.localStorage.setItem('vorelli_visit_count', String(visitCount));
      } catch (error) {
        visitCount = 1;
      }

      if (visitCount >= 2) {
        publishOncePerSession('vorelli_repeat_visitor', 'repeat_visitor', {
          event_category: 'journey',
          visit_count: visitCount,
          conversion_role: 'diagnostic'
        });
      }

      if (context.customer && context.customer.logged_in) {
        publishOncePerSession('vorelli_returning_customer', 'returning_customer', {
          event_category: 'customer',
          conversion_role: 'diagnostic'
        });
      }
    }

    function videoTitle(video) {
      return video.getAttribute('title') || video.getAttribute('aria-label') || video.getAttribute('data-video-title') || video.currentSrc || video.src || 'video';
    }

    function trackVideo(video, index) {
      var key = 'video_' + index;
      var thresholds = [25, 50, 75, 100];

      trackedVideoThresholds[key] = {};

      video.addEventListener('timeupdate', function () {
        var duration = video.duration;
        var percent;

        if (!duration || !Number.isFinite(duration)) {
          return;
        }

        percent = Math.floor((video.currentTime / duration) * 100);

        thresholds.forEach(function (threshold) {
          if (percent >= threshold && !trackedVideoThresholds[key][threshold]) {
            trackedVideoThresholds[key][threshold] = true;
            publish('watch_video_' + threshold, {
              event_category: 'video',
              video_title: videoTitle(video),
              video_src: video.currentSrc || video.src,
              video_percent: threshold,
              conversion_role: 'diagnostic'
            });
          }
        });
      });
    }

    function trackVideos() {
      var videos = document.querySelectorAll('video');
      var i;

      for (i = 0; i < videos.length; i += 1) {
        trackVideo(videos[i], i);
      }
    }

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = Math.max(1, doc.scrollHeight - window.innerHeight);
      var progress = (window.scrollY || doc.scrollTop || 0) / scrollable;

      if (progress >= 0.5) {
        publishEngagedUser('scroll_50');
        publishAuthorityEngagement('scroll_50');
        window.removeEventListener('scroll', onScroll);
      }
    }

    function onCalculatorInteraction(event) {
      var target = event.target;
      var guide = pagePayload().landing_page_group;

      if (guide !== 'authority_guide_staircase_chandelier_size' || !target) {
        return;
      }

      if (target.closest && target.closest('input, select, textarea, button, [data-calculator], .calculator')) {
        publishCalculatorInteraction(event.type);
        document.removeEventListener('change', onCalculatorInteraction, true);
        document.removeEventListener('click', onCalculatorInteraction, true);
      }
    }

    function restoreMobileCollectionNavLabels() {
      var labelsByPath = {
        '/collections/luxury-lighting': 'View All',
        '/collections/staircase-chandeliers': 'Staircase Chandeliers',
        '/collections/rectangular-chandeliers': 'Rectangular Chandeliers',
        '/collections/circular-chandeliers': 'Circular Chandeliers',
        '/collections/ceiling-lights': 'Ceiling Lights',
        '/collections/pendant-lights': 'Pendant Lights',
        '/collections/luxury-wall-lights': 'Wall Lights'
      };
      var links = document.querySelectorAll('.header__mobile-scroll-nav-link');
      var i;

      for (i = 0; i < links.length; i += 1) {
        var link = links[i];
        var path;
        var label;

        try {
          path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
        } catch (error) {
          path = '';
        }

        label = labelsByPath[path];

        if (label) {
          link.textContent = label;
          link.removeAttribute('data-vorelli-full-label');
        }
      }
    }

    document.addEventListener('pointerdown', onActionIntent, true);
    document.addEventListener('mousedown', onActionIntent, true);
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('focusin', onFormStart, true);
    document.addEventListener('input', onFormStart, true);
    document.addEventListener('change', onCalculatorInteraction, true);
    document.addEventListener('click', onCalculatorInteraction, true);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', restoreMobileCollectionNavLabels);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        restoreMobileCollectionNavLabels();
        setTimeout(restoreMobileCollectionNavLabels, 250);
        setTimeout(restoreMobileCollectionNavLabels, 1000);
        watchWhatsAppLinks();
        hydrateEmailMarketingConsentFields();
        setTimeout(hydrateEmailMarketingConsentFields, 500);
        publishPhoneNumberView();
        publishReturningVisitorState();
        publishListView();
        publishAuthorityView();
        trackVideos();
        setTimeout(function () {
          publishEngagedUser('time_30_seconds');
          publishAuthorityEngagement('time_30_seconds');
        }, 30000);
      });
    } else {
      restoreMobileCollectionNavLabels();
      setTimeout(restoreMobileCollectionNavLabels, 250);
      setTimeout(restoreMobileCollectionNavLabels, 1000);
      watchWhatsAppLinks();
      hydrateEmailMarketingConsentFields();
      setTimeout(hydrateEmailMarketingConsentFields, 500);
      publishPhoneNumberView();
      publishReturningVisitorState();
      publishListView();
      publishAuthorityView();
      trackVideos();
      setTimeout(function () {
        publishEngagedUser('time_30_seconds');
        publishAuthorityEngagement('time_30_seconds');
      }, 30000);
    }
  })();
